export default "__VITE_ASSET__BoF4Lel0__"